export default __webpack_public_path__ + "static/media/mars49.2991ea29.gif";